// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"PopupContent__Wrapper_3GabW","Title":"PopupContent__Title_3RnYo"};